/* eslint-disable no-undef, no-console, no-alert, no-unused-vars */
/* global customElements, document, window */
import { RewardsLauncher } from './RewardsLauncher.js';
import { RewardsPanel } from './RewardsPanel.js';

export function defineComponents() {
	customElements.define( 'rewards-launcher', RewardsLauncher );
	customElements.define( 'rewards-panel', RewardsPanel );
}

export function toggleRewardsPanel() {
	window.dispatchEvent( new CustomEvent( 'toggle-rewards-panel' ) );
}